module.exports = __webpack_public_path__ + "static/media/social-media-1.53a584bd.png";